// Historie auditů.
// (Krok B1b: rozděleno ze src/app.js beze změny kódu; importy/exporty doplněny automaticky.)
import { ICONS, auditNoValue, auditTouchesWorkplace, auditWorkplaceIds, closedAudits, esc, isMyClosedAudit, matchesAuditGroup, normalizeSearchText, scopeMine, scopeWorkplaceSet, state, auditMatchesWpFilter } from '../core/state.js';
import { auditUsesOkNok } from './audit-runner.js';
import { allCorrectiveItems, auditCorrectiveSeqMap, correctiveCode, correctiveCodeMatches, correctiveCodeQuery, isCorrectiveOverdue } from './corrective.js';

// ================= HISTORY =================
function matchesHistorySearch(a, term){
  if(!term) return true;
  // ID opatření (OP-152-2) → audit, ze kterého opatření pochází.
  var cq = correctiveCodeQuery(term);
  if(cq){
    var seqs = auditCorrectiveSeqMap(a);
    return Object.keys(seqs).some(function(k){ return correctiveCodeMatches(correctiveCode(a, seqs[k]), cq); });
  }
  var parts = [a.workplaceName, a.branchName, a.auditTypeName, a.auditorName,
    a.auditNumber!=null ? auditNoValue(a) : null].concat(a.participants||[]);
  (a.answers||[]).forEach(function(ans){
    parts.push(ans.questionText);
    if(ans.correctiveAction){
      parts.push(ans.correctiveAction.description);
      parts.push(ans.correctiveAction.responsible);
    }
    (ans.subAnswers||[]).forEach(function(sub){
      parts.push(sub.questionText || sub.text);
      if(sub.correctiveAction){
        parts.push(sub.correctiveAction.description);
        parts.push(sub.correctiveAction.responsible);
      }
    });
  });
  (Array.isArray(a.findings) ? a.findings : []).forEach(function(f){
    parts.push(f.note, f.workplaceName);
    if(f.correctiveAction){ parts.push(f.correctiveAction.description, f.correctiveAction.responsible); }
  });
  var hay = normalizeSearchText(parts.filter(Boolean).join(' '));
  return hay.indexOf(normalizeSearchText(term))>=0;
}
// Společné řazení pro seznamy. selectId zůstává (posluchač change se
// připojuje po vykreslení jako dřív), toggleFn = název App funkce pro směr.
function sortControlHtml(selectId, options, sortBy, sortDir, toggleFn){
  var cur = options.find(function(o){ return o.id===sortBy; }) || options[0];
  return '<div class="sort-ctl">' +
    '<label class="sort-pill" title="Řadit podle">'+ICONS.sort+'<span class="sort-label">'+esc(cur.label)+'</span>' +
    '<select id="'+selectId+'" aria-label="Řadit podle">' +
    options.map(function(o){ return '<option value="'+o.id+'" '+(sortBy===o.id?'selected':'')+'>'+esc(o.label)+'</option>'; }).join('') +
    '</select></label>' +
    '<button type="button" class="sort-dir-btn" title="'+(sortDir==='asc'?'Vzestupně':'Sestupně')+'" aria-label="'+(sortDir==='asc'?'Vzestupně':'Sestupně')+'" onclick="App.'+toggleFn+'()">'+
    (sortDir==='asc'?ICONS.up:ICONS.down)+'</button></div>';
}
var HISTORY_SORT_OPTIONS = [
  {id:'closedAt', label:'Datum', defaultDir:'desc'},
  {id:'result', label:'Výsledek', defaultDir:'asc'},
  {id:'workplace', label:'Pracoviště', defaultDir:'asc'},
  {id:'auditType', label:'Druh', defaultDir:'asc'},
  {id:'auditor', label:'Auditor', defaultDir:'asc'}
];
function historySortValue(a, sortBy){
  switch(sortBy){
    case 'result':
      return (a.summary && a.summary.overall==='NOK') ? 1 : 0;
    case 'workplace':
      return (a.workplaceName||'').toLowerCase();
    case 'auditType':
      return (a.auditTypeName||'').toLowerCase();
    case 'auditor':
      return (a.auditorName||'').toLowerCase();
    case 'closedAt':
    default:
      return a.closedAt ? new Date(a.closedAt).getTime() : 0;
  }
}
// Seznam auditorů pro dropdown filtr v Historii — jen ti, kdo se skutečně
// objevují v uzavřených auditech, řazeno abecedně.
function historyAuditorOptions(){
  var seen = {}, out = [];
  closedAudits().forEach(function(e){
    var name = e[1].auditorName;
    if(name && !seen[name]){ seen[name]=true; out.push(name); }
  });
  out.sort(function(a,b){ return a.localeCompare(b,'cs'); });
  return out;
}
function filteredHistoryList(){
  var term = (state.historySearch||'').trim().toLowerCase();
  var from = state.historyDateFrom ? new Date(state.historyDateFrom+'T00:00:00') : null;
  var to = state.historyDateTo ? new Date(state.historyDateTo+'T23:59:59') : null;
  // Opatření se počítají přes všechny uzavřené audity jen jednou dopředu
  // (ne uvnitř filteru pro každý audit zvlášť) — filtruje se podle nich
  // jen když je filtr stavu opatření aktivní.
  var correctiveItemsAll = state.historyFilterCorrectiveStatus ? allCorrectiveItems() : null;
  // „Moje“ v Historii = jen audity, které jsem prováděl (rozhodnutí
  // uživatele); hledání podle ID opatření (OP-…) „Moje“ ignoruje.
  var idQuery = !!(term && correctiveCodeQuery(term));
  var mine = scopeMine('history') && !idQuery;
  var wpSet = idQuery ? null : scopeWorkplaceSet('history');
  return closedAudits().filter(function(e){
    var a = e[1];
    if(mine && !isMyClosedAudit(a)) return false;
    // audit patří ke všem svým pracovištím i k pracovištím volných zjištění
    if(wpSet && !auditWorkplaceIds(a).concat((a.findings||[]).map(function(f){ return f.workplaceId; })).some(function(w){ return !!wpSet[w]; })) return false;
    if(!auditMatchesWpFilter(a, state.historyFilterWp)) return false;
    if(state.historyFilterType && a.auditTypeId!==state.historyFilterType) return false;
    if(state.historyFilterGroup && !matchesAuditGroup(a.auditTypeId, state.historyFilterGroup)) return false;
    if(state.historyFilterResult && (!a.summary || !auditUsesOkNok(a) || a.summary.overall!==state.historyFilterResult)) return false;
    if(state.historyFilterAuditor && a.auditorName!==state.historyFilterAuditor) return false;
    if(state.historyFilterCorrectiveStatus){
      var auditId = e[0];
      var items = correctiveItemsAll.filter(function(it){ return it.auditId===auditId; });
      if(state.historyFilterCorrectiveStatus==='overdue'){
        if(!items.some(function(it){ return isCorrectiveOverdue(it); })) return false;
      } else {
        var cstat = items.length===0 ? 'none' : (items.every(function(it){ return it.status==='hotovo' || it.status==='zruseno'; }) ? 'done' : 'open');
        if(cstat !== state.historyFilterCorrectiveStatus) return false;
      }
    }
    if(!matchesHistorySearch(a, term)) return false;
    if(from || to){
      var d = a.closedAt ? new Date(a.closedAt) : null;
      if(!d) return false;
      if(from && d<from) return false;
      if(to && d>to) return false;
    }
    return true;
  }).sort(function(e1,e2){
    var sortBy = state.historySortBy || 'closedAt';
    var av = historySortValue(e1[1], sortBy);
    var bv = historySortValue(e2[1], sortBy);
    var cmp = (typeof av === 'string') ? av.localeCompare(bv, 'cs') : (av - bv);
    if(cmp===0){
      cmp = new Date(e2[1].closedAt||0) - new Date(e1[1].closedAt||0);
    }
    return state.historySortDir==='desc' ? -cmp : cmp;
  });
}

export {
  HISTORY_SORT_OPTIONS,
  filteredHistoryList,
  historyAuditorOptions,
  sortControlHtml
};
